let scrollPos = 0;
let menuOffset;

var menu = document.getElementById("main-menu");
var mobMenu = document.getElementById("mobile-menu");
var menuWrapper = document.getElementById("menu-wrapper");

window.onscroll = function () {
    var bodyRect = document.body.getBoundingClientRect(),
        elemRect = menuWrapper.getBoundingClientRect();
    menuOffset = elemRect.top - bodyRect.top + 95;
    
    stickyMenu();
};

function stickyMenu() {

    var isSticky = hasClass(menu, "sticky");

    if (window.pageYOffset > menuOffset && !isSticky) {
        menu.classList.add("sticky");
        mobMenu.classList.add("sticky");
    } else if (window.pageYOffset < menuOffset) {
        menu.classList.remove("sticky");
        menu.classList.remove("show");
        mobMenu.classList.remove("sticky");
        mobMenu.classList.remove("show");
    }

    if (scrollDirection() === "up" && isSticky) {
        menu.classList.add("show");
        mobMenu.classList.add("show");
    } else if (scrollDirection() === "down" && isSticky) {
        menu.classList.remove("show");
        mobMenu.classList.remove("show");
    }

}

function scrollDirection() {
    var scrollDirection;
    if ((document.body.getBoundingClientRect()).top > scrollPos) {
        scrollDirection = "up";
    } else {
        scrollDirection = "down";
    }
    scrollPos = (document.body.getBoundingClientRect()).top;
    return scrollDirection;
}

function hasClass(element, cls) {
    return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
}